<template>
<div class="content">
	<div class="container inventory">
		<div class="row">
			<div class="col-sm-12">
				<h1>Saved Vehicles</h1>
				<vehicle :car="car" v-for="car in cars" :saved="savedDetails(car.vin)" :key="car.vin"></vehicle>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import config from '@/config';
import SavedButton from '@/components/SavedButton';
import VehicleCard from '@/components/VehicleCard';
import { mapMutations } from 'vuex';
import _ from 'lodash';
import axios from 'axios';
export default {
	components: {
		saved: SavedButton,
		vehicle: VehicleCard
	},
	data() {
		return {
			cars: []
		}
	},
	head() {
      return {
        title: "PRE-USED EV - Saved Vehicles",
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: 'Save your favorite cars on preusedev.com'
          }
        ]
	  }
    },
	methods: {
		savedDetails(vin){
			var r = -1;
			this.$store.state.saved.cars.forEach(function(car, i){
				if(car.vin == vin){
					r = i;
				}
				try{
					ga('send', 'event', 'saved_cars', 'view', vin);
				}catch(e){
					console.log(e);
				}

			});
			if(r >= 0){
				return this.$store.state.saved.cars[r];
			}
			return false;
		},
		async getCars(){
			let formData = {
				action: "get_saved",
			};

			const encodeForm = (data) => {
				return Object.keys(data)
					.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
					.join('&');
			}

			var queryString = encodeForm(formData);
			this.savedCars.map(function(value, key){
				queryString += "&car[]="+ encodeURIComponent(value.vin);
			});

			const [carsRes] = await Promise.all([
				axios.post(config.API_URL+"?"+queryString),
			]);

			this.cars = carsRes.data.data;

		}
	},
	watch: {
		savedCars(oldVal, newVal){
			this.getCars();
		}
	},
	props: {
	},
	computed: {
		savedCars(){
			return this.$store.state.saved.cars;
		},

	},
	mounted(){
		var local = this;
		local.getCars();
	},

}
</script>
<style lang="scss">
</style>
